'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dUser$002dCode$0024 from "./presto.types$-User-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_UsersView$$anon$41(outer) {
  this.bOp = null;
  this.bOn = null;
  this.bOo = false;
  this.bOl = null;
  this.bOm = false;
  this.bOq = false;
  this.bOr = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bOp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_UsersView$$anon$41 as $c_Lpresto_UsersView$$anon$41 };
$p = $c_Lpresto_UsersView$$anon$41.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_UsersView$$anon$41;
/** @constructor */
function $h_Lpresto_UsersView$$anon$41() {
}
export { $h_Lpresto_UsersView$$anon$41 as $h_Lpresto_UsersView$$anon$41 };
$h_Lpresto_UsersView$$anon$41.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bOp;
});
$p.t = (function() {
  if ((!this.bOo)) {
    this.bOn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bOo = true;
  }
  return this.bOn;
});
$p.ae = (function() {
  if ((!this.bOm)) {
    this.bOl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dCode$0024.$m_Lpresto_types$UserCode$().a2I(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bOm = true;
  }
  return this.bOl;
});
$p.w = (function() {
  if ((!this.bOr)) {
    this.bOq = false;
    this.bOr = true;
  }
  return this.bOq;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_UsersView$$anon$41 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_UsersView$$anon$41, "presto.UsersView$$anon$41", ({
  US: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_UsersView$$anon$41 as $d_Lpresto_UsersView$$anon$41 };
//# sourceMappingURL=presto.-Users-View$$anon$41.js.map
